/*
 * Copyright (c) 2024-2025 Nodals AI Ltd
 * All rights reserved.
 */

import { Logger } from '../../../logger';

import type { PermutiveConfig } from '../../../types/vendor/permutive';

const logger = Logger.getInstance();
const DEFAULT_STORAGE_KEY: string = '_psegs';

class PermutiveFacts {
  static get(config: PermutiveConfig): string[] {
    if (config?.enabled !== false) {
      if (config?.cohorts && Array.isArray(config.cohorts)) {
        return config.cohorts.map(String);
      }
      const localStorageKey = config?.storageKey ?? DEFAULT_STORAGE_KEY;
      const entry = localStorage.getItem(localStorageKey);
      if (entry) {
        logger.debug('Permutive cohort data located in local storage.');
        try {
          const data = JSON.parse(entry);
          if (Array.isArray(data)) {
            return data.map(String);
          } else {
            logger.warn('Extracted unexpected Permutive data structure');
          }
        } catch (error) {
          logger.warn(`Error parsing Permutive data: ${error}`);
        }
      }
    }
    return [];
  }
}

export { PermutiveFacts };
